var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30713 0.397418L8.00005 6.09033L13.693 0.397397C14.2203 -0.129943 15.0753 -0.129943 15.6027 0.397397C16.13 0.924736 16.13 1.77972 15.6027 2.30706L9.90972 8L15.6027 13.6929C16.13 14.2203 16.13 15.0753 15.6027 15.6026C15.0753 16.1299 14.2203 16.1299 13.693 15.6026L8.00005 9.90967L2.30713 15.6026C1.77979 16.1299 0.9248 16.1299 0.397459 15.6026C-0.129881 15.0752 -0.129881 14.2202 0.397458 13.6929L6.09038 8L0.397458 2.30708C-0.129882 1.77974 -0.129882 0.924758 0.397458 0.397418C0.924799 -0.129922 1.77979 -0.129922 2.30713 0.397418Z",
    fill: "#737381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.68f680bb2ff0c32abf573993a53aeaae.svg";
export { ForwardRef as ReactComponent };